import actions from '@/store/auth/actions';

const authModule = {
  state: () => ({
    idToken: null,
    id: null,
    role: '',
    email: '',
    firstName: '',
    lastName: '',
    avatarUrl: '',
    isLoggedIn: false,
    error: null,
    refreshToken: null,
    permissions: [],
    pagePermissions: [],
    company: null,
  }),
  getters: {
    isCompanyUser: (state) => state.company && state.company.id && state.company.pageKey,
  },
  mutations: {
    loginSuccess(state, data) {
      state.idToken = data.accessToken || data.token;
      state.isLoggedIn = true;
      state.error = null;
    },
    userProfileSuccess(state, data) {
      state.id = data.id;
      state.role = data.role;
      state.email = data.email;
      state.firstName = data.firstName;
      state.lastName = data.lastName;
      state.avatarUrl = data.avatarUrl;
      state.permissions = data.permissions || [];
      state.pagePermissions = data.pagePermissions || [];
      state.company = data.company || null;
    },
    loginFailure(state, message) {
      state.idToken = null;
      state.isLoggedIn = false;
      state.refreshToken = null;
      state.email = '';
      state.firstName = '';
      state.lastName = '';
      state.avatarUrl = '';
      state.permissions = [];
      state.pagePermissions = [];
      state.company = null;
      state.error = message;
    },
    logout(state) {
      state.idToken = null;
      state.isLoggedIn = false;
      state.refreshToken = null;
      state.email = '';
      state.firstName = '';
      state.lastName = '';
      state.avatarUrl = '';
      state.permissions = [];
      state.pagePermissions = [];
      state.company = null;
      window.location.href = '/';
    },
  },
  actions,
  namespaced: true,
};

export default authModule;
